<template>
  <div class="numberCircle">
    {{duration.toFixed(2)}}
    <span class="circle-unit">Sec</span>
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    number(newValue) {
      this.duration = newValue;
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.numberCircle {
  border-radius: 50%;
  width: 5em;
  height: 5em;
  padding: $spacer * 5;

  background: #fff;
  border: 1px solid #ffffff;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  color: #000000;
  text-align: center;

  font-size: $font-size-lg * 3;
  font-weight: bolder;
  margin: $spacer * 2 auto;
  .circle-unit {
    display: inline;
    color: #b5b5b5;
    font-size: $font-size-base * 2;
    font-weight: normal;
  }
}

@media (max-width: 575px) {
  .numberCircle {
    font-size: $spacer * 1.75;
    padding-left: unset;
    padding-right: unset;
    padding: 0em;
    padding-top: $spacer * 3;
    .circle-unit {
      display: inline;
      color: #b5b5b5;
      font-size: $font-size-base;
      font-weight: normal;
    }
  }
}

@media (min-width: 576px) and (max-width: 1300px) {
  .numberCircle {
    border-radius: 50%;
    width: 6em;
    height: 6em;
    padding: 3.5rem;
    background: #fff;
    border: 1px solid #ffffff;
    -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    color: #000000;
    text-align: center;
    font-size: 2em;
    font-weight: bolder;
    margin-top: 2.5rem;
    .circle-unit {
      display: inline;
      color: #b5b5b5;
      font-size: $font-size-base * 1;
      font-weight: normal;
    }
  }
}

@media (min-width: 1301px) and (max-width: 1600px) {
  .numberCircle {
    border-radius: 50%;
    width: 5em;
    height: 5em;
    padding: $spacer * 4.5;

    background: #fff;
    border: 1px solid #ffffff;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    color: #000000;
    text-align: center;

    font-size: $font-size-lg * 2.5;
    font-weight: bolder;
    .circle-unit {
      display: inline;
      color: #b5b5b5;
      font-size: $font-size-base * 2;
      font-weight: normal;
    }
  }
}
</style>
